// src/components/StartTimeInput.js
import React, { useState, useRef } from 'react';
import './StartTimeInput.css'; // Optional: For styling
import SegmentedControlAmPm from './SegmentedControlAmPm';

const StartTimeInput = ({ onStartTimeChange }) => {
  const [hour, setHour] = useState('');
  const [minute, setMinute] = useState('');
  const [period, setPeriod] = useState('AM');
  const [error, setError] = useState('');

  const handleHourChange = (e) => {
    const value = e.target.value;
    if (value === '' || (value >= 1 && value <= 12)) {
      setHour(value);
      onStartTimeChange(value, minute, period);
      setError(''); // Clear error when valid
    } else {
      setError('Please enter a valid hour (1-12)');
    }
  };

  const handleMinuteChange = (e) => {
    const value = e.target.value;
    if (value === '' || (value >= 0 && value <= 59)) {
      setMinute(value);
      onStartTimeChange(hour, value, period);
      setError(''); // Clear error when valid
    } else {
      setError('Please enter a valid minute (0-59)');
    }
  };

  const handlePeriodChange = (val) => {
    setPeriod(val);
    onStartTimeChange(hour, minute, val);
  };

  return (
    <div className="start-time-input">
      <label>Start time:</label>
      <div className="time-inputs">
        <input
          type="number"
          value={hour}
          onChange={handleHourChange}
          placeholder="HH"
          min="1"
          max="12"
          className="time-input"
          required
        />
        <span>:</span>
        <input
          type="number"
          value={minute}
          onChange={handleMinuteChange}
          placeholder="MM"
          min="0"
          max="59"
          className="time-input"
          required
        />
        <div className="period-selector">
          <SegmentedControlAmPm
            name="group-1"
            callback={handlePeriodChange}
            defaultIndex={0}
            controlRef={useRef()}
            segments={[
              {
                label: 'AM',
                value: 'AM',
                ref: useRef(),
              },
              {
                label: 'PM',
                value: 'PM',
                ref: useRef(),
              }
            ]}
          />
        </div>
      </div>
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default StartTimeInput;

